
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import * as TrackCard from '@components/LibraryTrackCard';
import * as CourseCard from '@components/LibraryCourseCard';
import * as ModuleCard from '@components/LibraryModuleCard';
import DevelopActions from '~/actions/develop';

const TrainingAdd = () => {
    const params = useParams();
    const { activeTab } = params;

    const dispatch = useDispatch();
    
    const handleUpdate = (target) => (payload, files) => {
        const after = {
            type: 'GETLIBRARYTEMPLATESSEARCH_REQUEST',
            target,
            payload: { page: 1, perPage: 25, published: [1] },
        };
        const route = `/library/training?active=${activeTab}`;
        dispatch(DevelopActions.librarytemplatesaveRequest(payload, files, target, after, route));
    };

    const AddComponent = {
        tracks: TrackCard.Add,
        courses: CourseCard.Add,
        modules: ModuleCard.Add,
    }[activeTab];

    return (
        <ErrorBoundary>
            <AddComponent onUpdate={handleUpdate(activeTab)} />
        </ErrorBoundary>
    );
};

export default TrainingAdd;
